import { Paper } from "@mantine/core";
import { Headers } from "../components/ui/heading";
import Roles from "../components/UserRole/Role";

function UserRole() {
  return (
    <div className="min-h-screen flex flex-col">
      <Paper shadow="xs" p="xl">
        <div className="mb-4 flex-shrink-0">
          <Headers name="User Roles" />
        </div>
        <div className="flex-1">
          <Roles />
        </div>
      </Paper>
    </div>
  );
}

export default UserRole;
